"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.callAppointmentStatus = callAppointmentStatus;
exports.callPatientWaitingRoom = callPatientWaitingRoom;
exports.default = watchers;
exports.postAnswersApi = postAnswersApi;
exports.sendCallEndDuration = sendCallEndDuration;
var _effects = require("redux-saga/effects");
var _sagas = require("../../../astercore/auth/login/redux/sagas");
var api = _interopRequireWildcard(require("../api/api"));
var actions = _interopRequireWildcard(require("./actions"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function* getQuestionsApi(params) {
  try {
    yield (0, _effects.put)(actions.GET_QUESTIONS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getQuestions, tokenData);
    yield (0, _effects.put)(actions.GET_QUESTIONS_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_QUESTIONS_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* postAnswersApi(requestParams) {
  try {
    yield (0, _effects.put)(actions.POST_ANSWERS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.postAnswers, requestParams.data.params, tokenData);
    yield (0, _effects.put)(actions.POST_ANSWERS_API.success(mainResponse));
    requestParams.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.POST_ANSWERS_API.failure(err));
    requestParams.data.onFailure(err);
  }
}
function* getDocumentsApi(params) {
  try {
    yield (0, _effects.put)(actions.GET_DOCUMENTS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getDocuments, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_DOCUMENTS_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_DOCUMENTS_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* uploadDocumentsApi(params) {
  try {
    yield (0, _effects.put)(actions.UPLOAD_DOCUMENT_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.uploadDocument, params.data.params, tokenData);
    yield (0, _effects.put)(actions.UPLOAD_DOCUMENT_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.UPLOAD_DOCUMENT_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* submitDocumentsApi(params) {
  try {
    yield (0, _effects.put)(actions.SUBMIT_DOCUMENT_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.submitDocuments, params.data.params, tokenData);
    yield (0, _effects.put)(actions.SUBMIT_DOCUMENT_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.SUBMIT_DOCUMENT_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* deleteDocumentsApi(params) {
  try {
    yield (0, _effects.put)(actions.DELETE_DOCUMENT_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.deleteDocument, params.data.params, tokenData);
    yield (0, _effects.put)(actions.DELETE_DOCUMENT_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.DELETE_DOCUMENT_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* updateDocumentsApi(params) {
  try {
    yield (0, _effects.put)(actions.UPDATE_DOCUMENT_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.updateDocument, params.data.params, tokenData);
    yield (0, _effects.put)(actions.UPDATE_DOCUMENT_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.UPDATE_DOCUMENT_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* callPatientWaitingRoom(params) {
  try {
    yield (0, _effects.put)(actions.CALL_PATIENT_WAITING_ROOM_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.callPatientWaitingRoom, params.data.params, tokenData);
    yield (0, _effects.put)(actions.CALL_PATIENT_WAITING_ROOM_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.CALL_PATIENT_WAITING_ROOM_API.failure(err));
    params.data.onFailure(err);
  }
}
function* callAppointmentStatus(params) {
  try {
    yield (0, _effects.put)(actions.APPOITMENT_STATUS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.appointmentStatus, params.data.params, tokenData);
    yield (0, _effects.put)(actions.APPOITMENT_STATUS_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.APPOITMENT_STATUS_API.failure(err));
    params.data.onFailure(err);
  }
}
function* getQuestionsAnsApi(requestParams) {
  try {
    yield (0, _effects.put)(actions.GET_QUESTIONS_ANS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getQuestionsAnswer, requestParams.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_QUESTIONS_ANS_API.success(mainResponse));
    requestParams.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_QUESTIONS_ANS_API.failure(err));
    if (requestParams.data && requestParams.data.onFailure) {
      requestParams.data.onFailure(err);
    }
  }
}
function* uploadMultipleDocumentsApi(params) {
  try {
    yield (0, _effects.put)(actions.UPLOAD_MULTIPLE_DOCUMENT_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.all)(params.data.params.map(param => function* () {
      try {
        return {
          error: false,
          result: yield (0, _effects.call)(api.uploadDocument, param, tokenData)
        };
      } catch (e) {
        return {
          error: true,
          result: e
        };
      }
    }()));
    const successRes = mainResponse.filter(res => !res.error) || [];
    if (successRes.length) {
      yield (0, _effects.put)(actions.UPLOAD_MULTIPLE_DOCUMENT_API.success(successRes.map(res => res.result)));
      params.data.onSuccess(successRes.map(res => res.result));
      return successRes;
    } else {
      var _params$data;
      yield (0, _effects.put)(actions.UPLOAD_MULTIPLE_DOCUMENT_API.failure());
      if (params.data && (_params$data = params.data) !== null && _params$data !== void 0 && _params$data.onFailure) {
        params.data.onFailure();
      }
    }
  } catch (err) {
    var _params$data2;
    yield (0, _effects.put)(actions.UPLOAD_MULTIPLE_DOCUMENT_API.failure(err));
    if (params.data && (_params$data2 = params.data) !== null && _params$data2 !== void 0 && _params$data2.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* deleteMultipleDocumentsApi(params) {
  try {
    yield (0, _effects.put)(actions.DELETE_MULTIPLE_DOCUMENT_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.all)(params.data.params.map(param => function* () {
      try {
        return {
          error: false,
          result: yield (0, _effects.call)(api.deleteDocument, param, tokenData)
        };
      } catch (e) {
        return {
          error: true,
          result: e
        };
      }
    }()));
    const successRes = mainResponse.filter(res => !res.error) || [];
    if (successRes.length) {
      yield (0, _effects.put)(actions.DELETE_MULTIPLE_DOCUMENT_API.success(successRes.map(res => res.result)));
      params.data.onSuccess(successRes.map(res => res.result));
      return successRes;
    } else {
      var _params$data3;
      yield (0, _effects.put)(actions.DELETE_MULTIPLE_DOCUMENT_API.failure());
      if (params.data && (_params$data3 = params.data) !== null && _params$data3 !== void 0 && _params$data3.onFailure) {
        params.data.onFailure();
      }
    }
  } catch (err) {
    yield (0, _effects.put)(actions.DELETE_MULTIPLE_DOCUMENT_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* sendCallEndDuration(params) {
  try {
    yield (0, _effects.put)(actions.SEND_CALL_END_DURATION_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.sendCallEndDuration, params.data.params, tokenData);
    yield (0, _effects.put)(actions.SEND_CALL_END_DURATION_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.SEND_CALL_END_DURATION_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* watchers() {
  yield (0, _effects.takeLatest)(actions.GET_QUESTIONS, getQuestionsApi);
  yield (0, _effects.takeLatest)(actions.POST_ANSWERS, postAnswersApi);
  yield (0, _effects.takeLatest)(actions.GET_DOCUMENTS, getDocumentsApi);
  yield (0, _effects.takeLatest)(actions.UPLOAD_DOCUMENT, uploadDocumentsApi);
  yield (0, _effects.takeLatest)(actions.SUBMIT_DOCUMENT, submitDocumentsApi);
  yield (0, _effects.takeLatest)(actions.DELETE_DOCUMENT, deleteDocumentsApi);
  yield (0, _effects.takeLatest)(actions.UPDATE_DOCUMENT, updateDocumentsApi);
  yield (0, _effects.takeLatest)(actions.CALL_PATIENT_WAITING_ROOM, callPatientWaitingRoom);
  yield (0, _effects.takeLatest)(actions.APPOITMENT_STATUS, callAppointmentStatus);
  yield (0, _effects.takeLatest)(actions.GET_QUESTIONS_ANS, getQuestionsAnsApi);
  yield (0, _effects.takeLatest)(actions.UPLOAD_MULTIPLE_DOCUMENT, uploadMultipleDocumentsApi);
  yield (0, _effects.takeLatest)(actions.DELETE_MULTIPLE_DOCUMENT, deleteMultipleDocumentsApi);
  yield (0, _effects.takeLatest)(actions.SEND_CALL_END_DURATION, sendCallEndDuration);
}